module.exports = __webpack_public_path__ + "static/media/trieste-18.f5e490ba.jpg";